import { render, staticRenderFns } from "./InboxReservation.vue?vue&type=template&id=4a22361d&scoped=true&"
import script from "./InboxReservation.vue?vue&type=script&lang=js&"
export * from "./InboxReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22361d",
  null
  
)

export default component.exports